var React = require('react');

function Pen2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.27 9.298l7.623-7.624 2.459 2.459-7.624 7.624L1.27 9.298zM.027 13l2.717-.753L.78 10.283.027 13zM12.035.382a1.307 1.307 0 00-1.845 0l-.554.553 2.458 2.459.554-.554c.51-.51.51-1.336 0-1.846l-.613-.612z","fill":"currentColor"}));
}

Pen2.defaultProps = {"viewBox":"0 0 14 13","fill":"none"};

module.exports = Pen2;

Pen2.default = Pen2;
